import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Phone, PhoneCall } from "lucide-react";

interface LlamadaProps {
  userData: any;
}

const Llamada = ({ userData }: LlamadaProps) => {
  const handleCall = () => {
    window.location.href = "tel:960628208";
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <Card className="border-0 shadow-lg">
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="text-2xl">Fichaje por llamada telefónica</CardTitle>
              <CardDescription className="text-base mt-1">
                Ficha tu entrada o salida mediante llamada
              </CardDescription>
            </div>
            <Phone className="w-8 h-8 text-primary" />
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl p-6 text-center space-y-4">
            <PhoneCall className="w-12 h-12 text-primary mx-auto" />
            <div>
              <p className="text-sm text-muted-foreground mb-2">
                Línea directa
              </p>
              <p className="text-2xl font-bold">
                960 628 208
              </p>
            </div>
          </div>

          <Button
            onClick={handleCall}
            size="lg"
            className="w-full text-base font-semibold h-12 gradient-secondary shadow-lg hover:shadow-xl transition-all"
          >
            <Phone className="w-5 h-5 mr-2" />
            Llamar ahora
          </Button>

          <p className="text-sm text-muted-foreground text-center leading-relaxed">
            En caso de no disponer de conexión de datos puede fichar entrada o salida mediante llamada telefónica. Cuando la locución lo solicite debe marcar su DNI-NIE sin letras.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Llamada;
